// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Smq3v","DisabledButton":"Button_DisabledButton__c2zN4"};